 //Function to navigate to VC Viewer in full screen mode in interactive component

const handleFullScreenVCViewer = () => {
  window.open("./VCpublisher/index.html", "_blank");
};

export default handleFullScreenVCViewer;